<template>
  <vs-popup class="customer-account-limit-request-update-popup"
            id="popup"
            title="UPDATE CUSTOMER ACCOUNT LIMIT REQUEST"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="change_to" name="change_to" rules="required" v-slot="{ errors }">
                <small class="label">Change To <span class="text-danger">*</span></small>
                <vx-input-group class="">
                  <template slot="prepend">
                    <div class="prepend-text bg-success">
                      <span>{{account_currency}}</span>
                    </div>
                  </template>
                  <vs-input v-model="createForm.change_to"  name="change_to" class="w-full" label=""/>
                </vx-input-group>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="reason_for_change" name="reason_for_change" rules="required" v-slot="{ errors }">
                <small class="label">Reason for Change <span class="text-danger">*</span></small>
                <vs-textarea class="mb-0" v-model="createForm.reason_for_change" height="100px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="createForm.note" height="100px" />
              </ValidationProvider>
            </div>
          </div>


          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="created_by" name="created_by" rules="required" v-slot="{ errors }">
                <small class="label">Created By</small>
                <vs-input disabled v-model="createForm.created_by"  name="created_by" class="w-full" label=""/>
              </ValidationProvider>
            </div>
          </div>


          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      createForm: {},
      id: ''
    }
  }

export default {
  name: 'UpdateCustomerAccountLimitRequestPopUp',
  data () {
    return initialState()
  },
  props: {
    account_currency  : {
      type: String,
      default: '',
    }
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = id
        this.$vs.loading();
        await this.fetchCustomerAccountLimitRequest()
        this.$vs.loading.close();
        this.open = true;
      } catch (error) {

      }
    },

    async onClickCreateSite () {
      const vue = this;
      this.$vs.loading()
       try {

         // format decimal places
         this.createForm.change_to = (Number(this.createForm.change_to)).toFixed(2)

         await CustomerRepository.updateAccountLimitRequest(this.id, this.createForm)
         this.showSuccessMessage('Customer Account Limit Request updated successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async fetchCustomerAccountLimitRequest() {
      this.$vs.loading()
      const {data} = await CustomerRepository.getAccountLimitRequest(this.id)
      this.createForm =  data.data
      this.$vs.loading.close()
    }
  },
  async mounted () {

  },
  components: {},
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .customer-account-limit-request-update-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
